import { render, staticRenderFns } from "./CategoriesClouds.vue?vue&type=template&id=efdbf6f0&scoped=true&"
import script from "./CategoriesClouds.vue?vue&type=script&lang=js&"
export * from "./CategoriesClouds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdbf6f0",
  null
  
)

export default component.exports